import { Item } from './Item'

export enum CalendarFilterType {
    Pros = 'pros',
    Services = 'services',
    Classes = 'classes',
    Reservations = 'reservations',
    Resources = 'resources',
}

export class CalendarFilter {
    private _pros: string[] = []
    private _reservations: string[] = []
    private _classes: string[] = []
    private _services: string[] = []
    private _resources: string[] = []

    constructor() {
        this._pros = []
        this._reservations = []
        this._classes = []
        this._services = []
    }

    copy(): CalendarFilter {
        const copy = new CalendarFilter()

        copy._pros = [...this._pros]
        copy._reservations = [...this._reservations]
        copy._classes = [...this._classes]
        copy._services = [...this._services]

        return copy
    }

    get pros(): string[] {
        return this._pros
    }

    get reservations(): string[] {
        return this._reservations
    }

    get classes(): string[] {
        return this._classes
    }

    get services(): string[] {
        return this._services
    }

    get resources(): string[] {
        return this._resources
    }

    get isEmpty(): boolean {
        return !(
            this._pros.length > 0 ||
            this._reservations.length > 0 ||
            this._classes.length > 0 ||
            this._services.length > 0 ||
            this._resources.length > 0
        )
    }

    get hasItems(): boolean {
        return (
            this._reservations.length > 0 || this._classes.length > 0 || this._services.length > 0
        )
    }

    get hasPeople(): boolean {
        return this._pros.length !== 0
    }

    get hasResources(): boolean {
        return this._resources.length !== 0
    }

    get allItems(): string[] {
        return [...this._reservations, ...this._classes, ...this._services]
    }

    get allPeople(): string[] {
        return this._pros
    }

    get allResources(): string[] {
        return this._resources
    }

    removePersonWithId(personId: string): void {
        this._pros = this._pros.filter((id) => id !== personId)
    }

    removeItemWithId(itemId: string): void {
        this._reservations = this._reservations.filter((id) => id !== itemId)
        this._classes = this._classes.filter((id) => id !== itemId)
        this._services = this._services.filter((id) => id !== itemId)
    }

    removeResourceWithId(resourceId: string): void {
        this._resources = this._resources.filter((id) => id !== resourceId)
    }

    removeIdByType(id: string, type: CalendarFilterType): void {
        if (type === CalendarFilterType.Pros)
            this._pros = this._pros.filter((proId) => proId !== id)
        else if (type === CalendarFilterType.Reservations)
            this._reservations = this._reservations.filter((reservationId) => reservationId !== id)
        else if (type === CalendarFilterType.Classes)
            this._classes = this._classes.filter((classId) => classId !== id)
        else if (type === CalendarFilterType.Services)
            this._services = this._services.filter((serviceId) => serviceId !== id)
    }

    addIdByType(id: string, type: CalendarFilterType): void {
        if (type === CalendarFilterType.Pros) this._pros.push(id)
        else if (type === CalendarFilterType.Reservations) this._reservations.push(id)
        else if (type === CalendarFilterType.Classes) this._classes.push(id)
        else if (type === CalendarFilterType.Services) this._services.push(id)
        else if (type === CalendarFilterType.Resources) this._resources.push(id)
    }

    addItem(item: Item): void {
        if (!item) return

        if (item.type === 'reservation') this._reservations.push(item.id!)
        else if (item.type === 'class') this._classes.push(item.id!)
        else if (item.type === 'service') this._services.push(item.id!)
    }

    removeAllOfType(type: CalendarFilterType): void {
        if (type === CalendarFilterType.Pros) this._pros = []
        else if (type === CalendarFilterType.Reservations) this._reservations = []
        else if (type === CalendarFilterType.Classes) this._classes = []
        else if (type === CalendarFilterType.Services) this._services = []
        else if (type === CalendarFilterType.Resources) this._resources = []
    }
}
